/**
 * This is an unpublished work containing 3M confidential and proprietary information.
 * Disclosure, use or reproduction without the written authorization of 3M is prohibited.
 * If publication occurs, the following notice applies:
 * Copyright (C) 2025, 3M. All rights reserved.
 */

export type GalleryMode = "Ask Chat" | "3M Knowledge" | "3M Signals" | "Legal" | "DevOps" | "Reporting Portal" | "TEBG" | "PPMO" | "Travel & Expenses" | "ITSM" | "JIRA" | "HR";

export const MODES: GalleryMode[] = ["Ask Chat", "3M Knowledge", "DevOps"]; // , "3M Signals"];

export const maxRows = 2; // change in future if needed based on mode and/or screen size